"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var OutageInfobox = function OutageInfobox(props) {
  var outage = props.outage,
      bounds = props.bounds;
  var infoboxBody = props.infoboxBodyMethod(outage, bounds);
  var infoboxFooter = props.infoboxFooterMethod(outage);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, infoboxBody, infoboxFooter);
};

OutageInfobox.propTypes = {
  outage: _propTypes.default.any.isRequired,
  bounds: _propTypes.default.any,
  infoboxBodyMethod: _propTypes.default.func.isRequired,
  infoboxFooterMethod: _propTypes.default.func.isRequired
};
var _default = OutageInfobox;
exports.default = _default;